<template>
    <AppDialog @close="close">
        <DialogTop
            :heading="heading"
            :top-icon="topIcon"
        >
            <slot name="topIcon"/>
        </DialogTop>
        <div class="content">
            <div
                v-if="item.type === 'image'"
                class="imageHolder"
            >
                <img
                    :src="item.extension === 'svg' ? item.source : item.sizes.small.url"
                    class="image w-full"
                >
            </div>
            <p class="title">{{ item.title }}.{{ item.extension }}</p>
            <FormGroup
                v-if="item.type === 'image'"
                label="Alt text"
                label-for="alt_text"
            >
                <InputField
                    v-model="newAlt"
                    name="alt_text"
                />
            </FormGroup>
            <FormGroup
                label="Private file (not indexed by search engines)"
            >
                <AppSwitch v-model="newPrivate"/>
            </FormGroup>
        </div>
        <div class="buttons">
            <AppButton
                :small="true"
                label="Cancel"
                class="isOutlined"
                @click="close"
            />
            <AppButton
                :small="true"
                label="Update"
                @click="update"
            />
        </div>
    </AppDialog>
</template>

<script>
import AppDialog from '../dialog/AppDialog.vue';
import DialogTop from '../dialog/DialogTop.vue';
import AppButton from '../ui/AppButton.vue';
import FormGroup from '../form/FormGroup.vue';
import InputField from '../form/InputField.vue';
import AppSwitch from '../form/AppSwitch.vue';
import { update } from '../../utils/apiHelper';

export default {
    components: {
        AppDialog,
        DialogTop,
        AppButton,
        FormGroup,
        InputField,
        AppSwitch,
    },
    props: {
        item: {
            type: Object,
            required: true,
        },
        heading: {
            type: String,
            required: true,
        },
    },
    data: () => ({
        newAlt: null,
        newPrivate: null,
    }),
    computed: {
        topIcon() {
            return !!this.$slots.topIcon;
        },
    },
    created() {
        this.newAlt = this.item.alt;
        this.newPrivate = !!this.item.private;
    },
    methods: {
        close() {
            this.$emit('close');
        },
        async update() {
            const res = await update(`/api/media/${this.item.id}`, {
                alt: this.newAlt,
                private: this.newPrivate,
            });

            if (res) {
                this.$emit('itemUpdated', res.data.item);
                this.close();
            }
        },
    },
};
</script>

<style lang="postcss" scoped>
.imageHolder {
    width: 180px;
    border-radius: var(--borderRadius);
    overflow: hidden;
    margin: 0 auto 25px;
}
.title {
    margin-bottom: 10px;
    font-weight: 500;
    font-size: 18px;
    overflow-wrap: break-word;
    word-wrap: break-word;
    word-break: break-word;
    hyphens: auto;
}
.buttons {
    display: flex;
    justify-content: flex-end;
    margin-top: 25px;
}
.buttons .appButton {
    margin-right: 10px;
    padding: 10px 25px;
    &:last-child {
        margin-right: 0;
    }
}
</style>
